// node_modules
import { FC, useRef, useState } from "react";
// Components
import { FileInputButton, FindestRefTextBox, ProseMirrorEditor } from "Components";
// Controllers
import { MediaControllerSingleton, ProseMirrorPluginControllerSingleton } from "Controllers";
// Types
import { TTechnologyImageDTO } from "Types";
// Styles
import styles from "styles/addMediaModal.module.scss";
// Helpers
import { ToastHelperSingleton } from "Helpers";
// Enums
import { ToastTypeEnum } from "Enums";

type TAddImageModal = {
    technologyId?: number,
    addImage?: (image: TTechnologyImageDTO) => void,
}

export const AddImageModal: FC<TAddImageModal> = ({technologyId, addImage}: TAddImageModal) => {

    const imageUrlTextboxRef = useRef<HTMLInputElement>(null);
    const [imageUrl, setImageUrl] = useState<string | undefined>(undefined);
    const [caption, setCaption] = useState<string>("");
    const [selectedFile, setSelectedFile] = useState<File | undefined>(undefined);

    const onFileSelected = (file: File) => {
        if(imageUrlTextboxRef.current) imageUrlTextboxRef.current.value = "";
        setImageUrl(undefined);
        setSelectedFile(file);
    };

    const getImageUrl = () => {
        const imageUrl = imageUrlTextboxRef.current;
        if(!imageUrl) return undefined;
        if(imageUrl.value.trim().length === 0) return undefined;
        return imageUrl.value;
    };

    const onAddImageClick = async () => {
        const imageUrl = getImageUrl();
        if(!imageUrl && !selectedFile) {
            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Please enter either an image url or select a local image to upload.");
            return;
        }

        let newlyAddedImage: TTechnologyImageDTO;

        if(selectedFile) {
            newlyAddedImage = await MediaControllerSingleton.AddLocalImageToTechnology(technologyId!, selectedFile, caption);
        } else {
            if(imageUrl) {
                newlyAddedImage = await MediaControllerSingleton.AddImageUrlToTechnology(technologyId!, imageUrl, caption);
            } else {
                ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Please enter either an image url or select a local image to upload.");
                return;
            }
        }

        if(addImage) addImage(newlyAddedImage);
    };

    const captionChanged = (text: string) => {
        setCaption(text);
    };

    const onUrlChange = () => {
        setSelectedFile(undefined);
        setImageUrl(getImageUrl());
    };

    return (
        <div className={styles.addMediaModalContainer}>
            <div className={styles.addMedia}>
                <span>Image url:</span>
                <FindestRefTextBox ref={imageUrlTextboxRef} onChange={onUrlChange} />
            </div>
            <div style={{margin: "0.5rem 0"}}>
                <span>or</span>
            </div>
            <div className={styles.addMedia}>
                <span>Local image:</span>
                <FileInputButton onFileSelected={onFileSelected} />
            </div>
            <div className={styles.aspectRatioBox}>
                <div className={styles.aspectRatioBoxContent}>
                    {selectedFile || imageUrl ? 
                        <img className={styles.image} src={selectedFile ? URL.createObjectURL(selectedFile) : imageUrl ? imageUrl : undefined} alt="Preview"/>
                    :
                        <div>Empty preview</div>
                    }
                    
                </div>
            </div>
            <div className={styles.captionContainer}>
                <span>Caption text</span>
                <ProseMirrorEditor source="" plugins={ProseMirrorPluginControllerSingleton.getDefault()} 
                    documentChanged={captionChanged} extraClassNameWisiwygContent={styles.captionText}/>
            </div>
            <button className={[styles.coloredButton, styles.purple].join(" ")} onClick={onAddImageClick}>Add image</button>
        </div>
    );
}